import React from 'react';
import { useLocationContext } from '../../context/LocationContext';

type Props = {
  children: React.ReactNode;
};

export default function AcquisitionOptions({ children }: Props) {
  const { errorState, zip, isExcludedLocation } = useLocationContext();

  if ((!zip && errorState.locationError) || isExcludedLocation) return null;

  return (
    <div
      data-qa="acquisition-options"
      data-testid="acquisition-options"
      className="flex w-full justify-evenly s:flex-col s:max-m:pb-48 m:flex-row m:py-32"
    >
      {children}
    </div>
  );
}
